import React from "react";
import {
  FaHandshake,
  FaUserTie,
  FaTicketAlt,
  FaMapMarkedAlt,
  FaHandsHelping,
} from "react-icons/fa";
import backgroundImage from "./assets/coreValuesBackground.png";
import "./css/coreValues.css";



export default function CoreValuesPage() {
  const cards = [
    {
      icon: <FaHandsHelping size={40}  />,
      title: "Customer Focus Inclusiveness",
      text: "Build strong business relationships.",
    },
    {
      icon: <FaHandshake size={40}  />,
      title: "Accountability",
      text: "Excellence in every interaction.",
    },
    {
      icon: <FaUserTie size={40} />,
      title: "Integrity",
      text: "Access exclusive experiences.",
    },
    {
      icon: <FaTicketAlt size={40} />,
      title: "Professionalism",
      text: "Explore global opportunities.",
    },
    {
      icon: <FaMapMarkedAlt size={40} />,
      title: "Impartiality Transparency",
      text: "We’re here to help you succeed.",
    },
  ];

  return (
    <div className="container my-5 bg-background">
      <h2 className="h2-core">
        <span className="line"></span>   
        CORE VALUES
        <span className="line"></span> 
      </h2>
      <div className="row text-center justify-content-center ">
        {cards.map((card, index) => (
          <div key={index} className="col-lg-2 col-md-4 col-sm-6 mb-4">
            <div className="card shadow-sm border-0 h-100">
              <div className="card-body d-flex flex-column align-items-center justify-content-center">
                <div className="mb-3 theme-color">{card.icon}</div>
                <h5 className="card-title fw-bold">{card.title}</h5>
                
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
